<template>
  <news-create-form></news-create-form>
</template>

<script>
import NewsCreateForm from "./CreateForm";
export default {
  name: "CreateProgramPage",
  components: { NewsCreateForm }
};
</script>

<style scoped></style>
